import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import Heading from '@atlaskit/heading';
import Image from '@atlaskit/image';
import { Text } from '@atlaskit/primitives/compiled';

import { i18n } from '../../AdvancedSearch-i18n.ts';
import { useAnalytics } from '../../AnalyticsProvider.tsx';

import { SearchMessagesContainer } from './styled.tsx';
import SearchLightImage from './images/Search.svg';
import SearchDarkImage from './images/SearchDark.svg';

export const SearchResultListNoInput = () => {
	const { fireAnalytics } = useAnalytics();
	useEffect(() => {
		fireAnalytics({
			type: 'sendTrackEvent',
			action: 'shown',
			actionSubject: 'advancedSearchPreQuery',
		});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<SearchMessagesContainer>
			<Image src={SearchLightImage} srcDark={SearchDarkImage} width="200" height="200" alt="" />
			<Heading size="medium" as="h6">
				<FormattedMessage {...i18n.landingPageHeader} />
			</Heading>
			<Text as="p">
				<FormattedMessage {...i18n.landingPageText} data-test-id="search-result-landing-text" />
			</Text>
		</SearchMessagesContainer>
	);
};
